const units = {
  s: { id: "s", name: "second", measureId: "time", baseUnit: 1 },
  min: { id: "min", name: "minute", measureId: "time", baseUnit: 60 },
  h: { id: "h", name: "hour", measureId: "time", baseUnit: 3600 },
  hard_boiled_egg: {
    id: "hard_boiled_egg",
    name: "hard-boiled egg",
    measureId: "time",
    baseUnit: 720,
  },
  超跑情人夢: {
    id: "超跑情人夢",
    name: "超跑情人夢",
    measureId: "time",
    baseUnit: 254,
  },

  m: { id: "m", name: "metre", measureId: "length", baseUnit: 1 },
  cm: { id: "cm", name: "cm", measureId: "length", baseUnit: 0.01 },
  km: { id: "km", name: "kilometre", measureId: "length", baseUnit: 1000 },
  mile: { id: "mile", name: "mile", measureId: "length", baseUnit: 1609.344 },
  marathon: {
    id: "marathon",
    name: "marathon",
    measureId: "length",
    baseUnit: 42195,
  },

  kg: { id: "kg", name: "kilogram", measureId: "mass", baseUnit: 1 },
  lb: { id: "lb", name: "lb", measureId: "mass", baseUnit: 0.454 },
  g: { id: "g", name: "gram", measureId: "mass", baseUnit: 0.001 },
  jin: { id: "jin", name: "jin", measureId: "mass", baseUnit: 0.6 },
  ipad_pro: {
    id: "ipad_pro",
    name: '11" iPad Pro',
    measureId: "mass",
    baseUnit: 0.4717361,
  },

  twd: { id: "twd", name: "TWD", measureId: "currency", baseUnit: 0.036 },
  usd: { id: "usd", name: "USD", measureId: "currency", baseUnit: 1 },
  eur: { id: "eur", name: "EUR", measureId: "currency", baseUnit: 1.21 },
  vip: {
    id: "vip",
    name: "annual VIP",
    measureId: "currency",
    baseUnit: 35.99,
  },

  liter: { id: "liter", name: "liter", measureId: "volume", baseUnit: 1 },
  cup: { id: "cup", name: "cup", measureId: "volume", baseUnit: 0.236588 },
  tbsp: { id: "tbsp", name: "tbsp", measureId: "volume", baseUnit: 0.0147868 },
  tsp: { id: "tsp", name: "tsp", measureId: "volume", baseUnit: 0.00492892 },
  ml: { id: "ml", name: "ml", measureId: "volume", baseUnit: 0.001 },
  beer: {
    id: "beer",
    name: "glass of beer",
    measureId: "volume",
    baseUnit: 0.473,
  },
  shot: {
    id: "shot",
    name: "shot of whisky",
    measureId: "volume",
    baseUnit: 0.02957352956,
  },
};
export default units;
